import type { BrandConfig } from '../../app/interfaces/brand-config';
import { iconConfig } from './iconConfig';

export const brandConfig: BrandConfig = {
  id: 'INS',
  name: 'Aceable Insurance',
  appName: 'AceableInsurance',
  url: 'insurance.aceable.com',
  hostName: 'insurance.aceable.com',
  siblingSites: ['aceable.com', 'aceableagent.com', 'mortgage.aceable.com'],
  showFee: true,
  feeLabel: 'State Reporting Fee',
  helpPage: '',
  cdiParamKey: '',
  vertical: 'insurance',
  craftSite: 'ins',
  cdiParamValueWhenEnabled: '',
  trustpilotId: '682656b886bcf0ed951b5d8e',
  trustpilotApiKey: 'Rk3yLGM8QWIj2ecbmB4s0rnG82OsU5PS',
  iterable: {
    appType: 'INS',
    brandId: 'ACE',
  },
  ambassadorIntegrationId: 39762,
  pricingText: '',
  altPricingText: '',
  productCategoryHandle: 'insuranceProductCategory',
  iconConfig: iconConfig,
  checkClassName: '',
  useLocationCookie: false,
  ctaText: 'Get My License',
  rsaImageFooterText: '',
  hubspotID: '',
  use_old_coupon_strategy: false,
  use_segment_signals: true,
  globalCDIQueryParam: 'hc',
  globalSalesQueryParam: 'vc',
  designMode: 'ace',
  defaultAda: '',
  defaultVideoDescription:
    'See how Aceable Insurance helps you launch and grow your insurance career with state-approved pre-licensing and continuing education courses for Property & Casualty and Life & Health.',
  termsOfServiceUrl: 'https://insurance.aceable.com/terms-and-conditions/',
  privacyPolicyUrl: 'https://insurance.aceable.com/privacy-policy/',
};
